export default "__VITE_ASSET__CNSz64J9__"